var $173e9fb4d14fe309$exports = {};
$173e9fb4d14fe309$exports = {
    "breadcrumbs": `Atpaka\u{13C}ce\u{13C}i`
};


export {$173e9fb4d14fe309$exports as default};
//# sourceMappingURL=lv-LV.module.js.map
